"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addBillingAppendixToBillingVouchers = exports.CreateBillingAppendixSetupSchema = exports.PatchBillingAppendixSetupSchema = exports.BillingAppendixSchema = exports.Timing = void 0;
const Joi = __importStar(require("joi"));
const zod_1 = __importDefault(require("zod"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
var Timing;
(function (Timing) {
    Timing["Manual"] = "MANUAL";
    Timing["ASAP"] = "ASAP";
    Timing["OnCaseEnd"] = "ON_CASE_END";
    Timing["Quarterly"] = "QUARTERLY";
    Timing["Monthly"] = "MONTHLY";
    Timing["Weekly"] = "WEEKLY";
})(Timing || (exports.Timing = Timing = {}));
exports.BillingAppendixSchema = zod_1.default.object({
    billingAppendixId: zod_1.default.string(),
    seqId: zod_1.default.number().optional(),
    handle: zod_1.default.string(),
    onlyVoucherTypeIds: zod_1.default.array(zod_1.default.string()).optional(),
    timing: zod_1.default.object({
        type: zod_1.default.string(),
        details: zod_1.default.object({}),
    }),
    hideFromCreditor: zod_1.default.boolean(),
    includeVatInDepositShare: zod_1.default.boolean(),
    createdAt: zod_1.default.string().optional(),
    createdBy: zod_1.default.any().optional(),
});
exports.PatchBillingAppendixSetupSchema = zod_1.default.object({
    name: zod_1.default.string().optional(),
    appendices: zod_1.default.array(exports.BillingAppendixSchema).optional(),
});
exports.CreateBillingAppendixSetupSchema = Joi.object({
    name: Joi.string(),
    appendices: Joi.array().items(Joi.object({
        billingAppendixId: Joi.string().uuid(),
        handle: Joi.string().required(),
        onlyVoucherTypeIds: Joi.array().items(Joi.string().uuid()).required(),
        timing: Joi.object({
            type: Joi.string()
                .valid(...Object.values(Timing))
                .required(),
            details: Joi.object().required(),
        }),
        hideFromCreditor: Joi.boolean(),
        includeVatInDepositShare: Joi.boolean(),
    })),
});
const addBillingAppendixToBillingVouchers = (billingAppendixSetup, newBillingVouchers, tenant) => {
    let newBillingVouchersToBeCreated = [];
    const newBillingVouchersToBeCreatedNotVat = newBillingVouchers.filter((billingVoucher) => !billingVoucher.vatOfBillingVoucherId);
    newBillingVouchersToBeCreated = newBillingVouchersToBeCreated.concat(newBillingVouchersToBeCreatedNotVat.map((newBillingVoucher) => setBillingAppendix(newBillingVoucher, billingAppendixSetup, tenant)));
    const newBillingVouchersToBeCreatedVat = newBillingVouchers.filter((billingVoucher) => billingVoucher.vatOfBillingVoucherId);
    newBillingVouchersToBeCreated = newBillingVouchersToBeCreated.concat(newBillingVouchersToBeCreatedVat.map((newBillingVoucher) => setBillingAppendixForVatVouchers(newBillingVoucher, billingAppendixSetup, newBillingVouchersToBeCreated, tenant)));
    return newBillingVouchersToBeCreated;
};
exports.addBillingAppendixToBillingVouchers = addBillingAppendixToBillingVouchers;
const setBillingAppendix = (billingVoucher, billingAppendixSetup, tenant) => {
    const billingAppendices = findBillingAppendices(billingVoucher, billingAppendixSetup);
    const billingAppendix = billingAppendices[0];
    if (billingAppendix) {
        billingVoucher.billingAppendixId = billingAppendix.billingAppendixId;
        billingVoucher.billAfter = getBillAfter(billingAppendix, billingVoucher, tenant);
    }
    return billingVoucher;
};
const setBillingAppendixForVatVouchers = (billingVoucher, billingAppendixSetup, billingVouchersNoVat, tenant) => {
    const vatOfVoucher = billingVouchersNoVat.find((_billingVoucher) => _billingVoucher.billingVoucherId === billingVoucher.vatOfBillingVoucherId);
    const billingAppendices = findBillingAppendices(billingVoucher, billingAppendixSetup);
    if (vatOfVoucher &&
        vatOfVoucher.billingAppendixId &&
        billingAppendices.find((appendix) => appendix.billingAppendixId === vatOfVoucher.billingAppendixId)) {
        billingVoucher.billingAppendixId = vatOfVoucher.billingAppendixId;
        billingVoucher.billAfter = vatOfVoucher.billAfter;
        return billingVoucher;
    }
    const billingAppendix = billingAppendices[0];
    if (billingAppendix) {
        billingVoucher.billingAppendixId = billingAppendix.billingAppendixId;
        billingVoucher.billAfter = getBillAfter(billingAppendix, billingVoucher, tenant);
    }
    return billingVoucher;
};
const findBillingAppendices = (billingVoucher, billingAppendixSetup) => {
    const appendices = billingAppendixSetup.appendices.filter((appendix) => {
        return appendix.onlyVoucherTypeIds
            ? appendix.onlyVoucherTypeIds.includes(billingVoucher.voucherTypeId)
            : true;
    });
    return appendices;
};
const getBillAfter = (billingAppendix, billingVoucher, tenant) => {
    switch (billingAppendix.timing.type) {
        case Timing.Weekly:
            return (0, moment_timezone_1.default)(billingVoucher.date)
                .tz(tenant.timezone)
                .endOf('week')
                .toISOString();
        case Timing.Monthly:
            return (0, moment_timezone_1.default)(billingVoucher.date)
                .tz(tenant.timezone)
                .endOf('month')
                .toISOString();
        case Timing.Quarterly:
            return (0, moment_timezone_1.default)(billingVoucher.date)
                .tz(tenant.timezone)
                .endOf('quarter')
                .toISOString();
        default:
            return null;
    }
};
//# sourceMappingURL=index.js.map